import { render, staticRenderFns } from "./EEditorFroala.vue?vue&type=template&id=468f12d3&"
import script from "./EEditorFroala.vue?vue&type=script&lang=js&"
export * from "./EEditorFroala.vue?vue&type=script&lang=js&"
import style0 from "GroomyRoot/assets/scss/editorFroala.css?vue&type=style&index=0&lang=css&"
import style1 from "GroomyRoot/assets/scss/froalaFont.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports